import React from 'react'

export function useClone<T = any>(elem?: React.ReactElement, props?: T) {
  if (React.isValidElement(elem)) {
    return React.cloneElement(elem, props || {})
  }

  return null
}
